import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) => state.gradeList.loading;
export const selectErrorMessage = (state: RootState) => state.gradeList.error;
export const gradeListDataResponse = (state: RootState) =>
  state.gradeList.gradeListResponse;
